import { render, staticRenderFns } from "./organisationDetails.vue?vue&type=template&id=a81bce66&scoped=true"
import script from "./organisationDetails.vue?vue&type=script&lang=js"
export * from "./organisationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81bce66",
  null
  
)

export default component.exports